<template>
	<div
		id="theMaintenanceMode"
		class="flex"
		:style="computedSetHeight"
	>
		<div class="centerBox">
			<div class="centerBoxHeader flex">
				<img
					src="../assets/images/notes/logo.png"
					alt="ロゴ"
					class="noteLogo"
				/>
				<span>NEXTO STORE</span>
			</div>
			<p class="centerBoxText">
				現在サービスを利用できません。<br>
				メンテナンス中か通信環境の問題が発生しています。<br>
				ご迷惑をおかけして、大変申し訳ありません。<br>
				時間をあけて再度お試しください。
				</p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'theMaintenanceMode',
	mixins: [],
	data () {
		return {
			height: 0
		}
	},
	computed: {
		computedSetHeight () {
			return `height: ${this.height}px`
		}
	},
	created () {
		window.addEventListener('resize', this.handleResize)
		this.handleResize()
	},
	mounted () {
		this.set()
	},
	methods: {
		set () {
			this.$store.dispatch('Utility/dohideLoading')
		},
		handleResize () {
			this.height = window.innerHeight
		}
	}
}
</script>

<style lang="stylus" scoped>
@import "~@/themes/styles/mixins.styl"
#theMaintenanceMode
	width 100%
	height 100%
	top 0
	left 0
	position fixed
	flex-direction column
	justify-content center
	text-align center
	background-color main-light-dark
	.centerBox
		margin 0 auto
		padding 15px 20px
		background-color #fff
		border-radius 20px
		max-width 310px
		.centerBoxHeader
			align-items center
			> img
				width 50px
				height 50px
				border-radius 8px
			> span
				font-size 1.2rem
				margin-left 6px
		.centerBoxText
			margin-top 24px
			text-align left
			font-size 0.8rem
</style>
